
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/pelaksanaan/pengembangan-kompetensi/edit",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/pelaksanaan/pengembangan-kompetensi/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/pelaksanaan/pengembangan-kompetensi/edit"])
      });
    }
  